import React, { useContext, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'
import Rockets from '../../assets/rockets.svg'
import AdxInput from 'components/custom/AdxInput'
import { superAdminOnboardingLink } from 'module/sign-up/config/superAdminUrl'
import { SuperAdminOnboardingContext } from 'module/sign-up/context/SuperAdminOnboardingContext'
import defaultAvatar from 'assets/images/default_avatar.png'
import { authContext } from 'contexts/AuthContext'
import AdxButton from 'components/custom/AdxButton'

const StepThree = () => {
  const { auth } = useContext(authContext)
  const {
    organization_name = '',
    address = '',
    postcode = '',
    state = '',
    country = '',
  } = auth?.data?.organization_detail || {}
  const companyAddress = `${address}, ${postcode}, ${state}, ${country}`
  const companyImage = null

  const navigate = useNavigate()
  const handleContinue = () => {
    navigate(superAdminOnboardingLink(4))
  }
  const handleBack = () => {
    navigate(superAdminOnboardingLink(2))
  }
  const { savedSuperAdminOnboardingSession, setSuperAdminOnboardingSession } = useContext(
    SuperAdminOnboardingContext
  )
  // save employee name
  const handleChange = (e) => {
    setSuperAdminOnboardingSession({
      ...savedSuperAdminOnboardingSession,
      designation: e.target.value,
    })
  }
  useEffect(() => {
    if (
      !savedSuperAdminOnboardingSession?.profile_photo &&
      !savedSuperAdminOnboardingSession?.name
    ) {
      handleBack()
    }
  }, [])

  return (
    <OnboardingContainer bgColorRight="white.main">
      <Box
        height={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'flex-end' }}
        alignItems="center"
      >
        <Box
          component="img"
          src={Rockets}
          position="fixed"
          bottom={0}
          right={0}
          width="calc(100vw * 0.8)"
          display={{ xs: 'none', lg: 'block' }}
        />
        <Box
          width={{ xs: '100%', lg: '500px' }}
          height={{ xs: '100vh', lg: '80vh' }}
          maxHeight={{ xs: '100vh', lg: '700px' }}
          mr={{ lg: 7.6875 }}
          p={{ xs: 2, lg: 0 }}
          position={'relative'}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box mb={4} display="flex" flexDirection="column" gap={0.5}>
            <Typography variant="body1" color="alternate.main" fontWeight="bold">
              Step 2
            </Typography>
            <Typography variant="h4" textAlign="justify" color="dark-text.main" fontWeight="bold">
              Job Information
            </Typography>
            <Box display="flex" justifyContent="space-between" my={4}>
              <Box width="150px" height="150px" position="relative">
                <Box
                  component="img"
                  src={companyImage || defaultAvatar}
                  width="140px"
                  height="140px"
                  borderRadius="100%"
                  position="absolute"
                  top={0}
                  left={0}
                  bgcolor="light-gray-text.main"
                />
                <Box
                  component="img"
                  src={savedSuperAdminOnboardingSession?.profile_photo?.preview || defaultAvatar}
                  width="70px"
                  height="70px"
                  borderRadius="100%"
                  position="absolute"
                  bottom={0}
                  right={0}
                  bgcolor="light-gray-text.main"
                  border={3}
                  borderColor="white.main"
                />
              </Box>
              <Box
                width="calc(100% - 180px)"
                height="150px"
                display="flex"
                flexDirection="column"
                gap={2}
              >
                <Box display="flex" flexDirection="column" gap={0.5}>
                  <Typography variant="body2" color="light-gray-text.main">
                    Company name
                  </Typography>
                  <Typography>{organization_name}</Typography>
                </Box>
                <Box display="flex" flexDirection="column" gap={0.5}>
                  <Typography variant="body2" color="light-gray-text.main">
                    Primary Address
                  </Typography>
                  <Typography>{companyAddress}</Typography>
                </Box>
              </Box>
            </Box>
            <AdxInput
              label="Designation"
              sxLabel={{
                color: 'black.main' /*, fontSize: "30px!important" */,
              }}
              sx={{
                marginBottom: '16px',
              }}
              size="standard"
              placeholder="Head Corporate"
              onChange={handleChange}
              value={savedSuperAdminOnboardingSession.designation}
            />
            <AdxInput
              label={<Typography color="light-gray-text.main">Department</Typography>}
              sxLabel={{
                color: 'black.main' /*, fontSize: "30px!important" */,
              }}
              sx={{
                marginBottom: '16px',
              }}
              size="standard"
              placeholder="Head of organization"
              value=""
              isErrorShown={true}
              errorMessage={
                <Typography mt={1} color="light-gray-text.main">
                  {`You can change the head of organization later in the company management page:
                  Company Management > Department`}
                </Typography>
              }
              disabled
              sxInput={{
                '&.Mui-disabled': {
                  outline: 'none',
                },
              }}
            />
          </Box>
          <Box width={1} mt={10} display="flex" gap={1}>
            <AdxButton
              variant={'outlined'}
              onClick={handleBack}
              sx={{ minWidth: '20px', pl: 3, borderWidth: 2 }}
            >
              {<ArrowBackIosIcon />}
            </AdxButton>
            <AdxButton
              fullWidth
              onClick={handleContinue}
              disabled={
                !savedSuperAdminOnboardingSession?.name ||
                !savedSuperAdminOnboardingSession?.profile_photo ||
                !savedSuperAdminOnboardingSession?.designation
              }
            >
              Continue
            </AdxButton>
          </Box>
        </Box>
      </Box>
    </OnboardingContainer>
  )
}

export default StepThree
